import React, { useState } from "react";
import { image } from "../../common/Theme";
import { RadioButton } from "../../component/Radio";
import FlagDropdown from "../../component/FlagDropdown";
import Validation from "../Validation/validation";
import { showError } from "../Validation";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Apiconnection from "../../utils/Apiconnection";
import { Button, Modal, Box, FormControl, TextField, TableBody, InputLabel, FormHelperText, MenuItem, Select, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';

const FeatureIcon = ({ icon, bgColor, title, desc, hasBorder }) => (
  <div style={{ flex: 1, padding: '0 10px', borderRight: hasBorder ? '1px solid #e2e8f0' : 'none', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div style={{ width: '56px', height: '56px', borderRadius: '50%', backgroundColor: bgColor, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px auto' }}>
      {icon}
    </div>
    <h4 style={{ fontSize: '15px', fontWeight: '800', color: '#0f172a', marginBottom: '6px', textAlign: 'center' }}>{title}</h4>
    <p style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.5', textAlign: 'center', maxWidth: '140px' }}>{desc}</p>
  </div>
);

const CustomerRegistration = () => {
    const [data, setData] = useState({
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        dialcode: "+61",
        dob: '',
        gender: '',
        address: '',
        profileImage: null
    });
    const [isPhoneFocused, setIsPhoneFocused] = useState(false);
    const [focusedField, setFocusedField] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [otpEmail, setOtpEmail] = useState('');
    const [otpPhone, setOtpPhone] = useState('');
    const [showOtpEmail, setshowOtpEmail] = useState('');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleChanges = (e) => {
        const { name, value } = e.target;

        // Example validation for DD/MM/YYYY format
        const datePattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(20[0-9]{2})$/;

        if (name === "dob") {
            if (!datePattern.test(value)) {
                setError((prev) => ({ ...prev, dob: "Invalid date format. Please use DD/MM/YYYY." }));
            } else {
                setError((prev) => ({ ...prev, dob: null })); // Clear error if valid
            }
        }

        // Update state for all fields
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    }

    const handleTogglePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        // Allow only digits for phone input
        if (name === 'phone') {
            const numericValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
            setData((prev) => ({ ...prev, [name]: numericValue }));
        } else if (name === 'profileImage') {
            setData((prev) => ({ ...prev, [name]: e.target.files[0] }));
        } else {
            setData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const validateForm = () => {
        let errors = {};
        let isValid = true;

        if (!data.firstName) {
            errors.firstName = "First Name is required.";
            isValid = false;
        }
        if (!data.lastName) {
            errors.lastName = "Last Name is required.";
            isValid = false;
        }
        if (!data.email) {
            errors.email = "Email is required.";
            isValid = false;
        } else if (!/^\S+@\S+\.\S+$/.test(data.email)) {
            errors.email = "Email address is invalid.";
            isValid = false;
        }

        if (!data.phone) {
            errors.phone = "Phone Number is required.";
            isValid = false;
        } else if (data.dialcode === '+61' && data.phone.length < 9) {
            errors.phone = "Phone Number must be at least 9 digits for Australia.";
            isValid = false;
        } else if (data.dialcode !== '+61' && data.phone.length < 10) {
            errors.phone = "Phone Number must be at least 10 digits.";
            isValid = false;
        }

        if (!data.password) {
            errors.password = "Password is required.";
            isValid = false;
        } else if (data.password.length < 6) {
            errors.password = "Password must be at least 6 characters.";
            isValid = false;
        }

        if (!data.confirmPassword) {
            errors.confirmPassword = "Confirm Password is required.";
            isValid = false;
        } else if (data.password !== data.confirmPassword) {
            errors.confirmPassword = "Passwords do not match.";
            isValid = false;
        }

        setError(errors);

        if (!isValid) {
            toast.error("Please correct the highlighted errors before submitting.");
        }

        return isValid;
    };

    // const handleCustomerSubmit = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm()) return;
    //     try {
    //         const formData = new FormData();
    //         formData.append('firstName', data.firstName);
    //         formData.append('lastName', data.lastName);
    //         formData.append('email', data.email);
    //         formData.append('password', data.password);
    //         formData.append('dialCode', "+1");
    //         formData.append('phone', data.phone);
    //         formData.append('dob', data.dob);
    //         formData.append('gender', 'male');
    //         formData.append('address', data.address);
    //         formData.append('profileImage', data.profileImage);

    //         const response = await Apiconnection.post('customer-register', formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //             },
    //         });
    //         console.log('Registration successful:', response);
    //         toast.success(response.data.message);
    //         setTimeout(() => {
    //             navigate('/login');
    //         }, 2000);
    //     } catch (error) {
    //         console.log('error', error);
    //         toast.error(error.response.data.message);
    //     }
    // };

    const handleCustomerSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('firstName', data.firstName);
            formData.append('lastName', data.lastName);
            formData.append('email', data.email);
            formData.append('password', data.password);
            formData.append('dialCode', data.dialcode);
            formData.append('phone', data.phone);
            formData.append('dob', data.dob);
            formData.append('gender', 'male');
            formData.append('address', data.address);
            formData.append('profileImage', data.profileImage);

            // Call the customer-register API
            const response = await Apiconnection.post('customer-register', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            // toast.success(response?.data?.message);
            setshowOtpEmail(response?.data?.otp?.emailOTP)
            setOtpModalOpen(true); // Open OTP modal after successful registration
        } catch (error) {
            console.log('error', error);
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async () => {
        setLoading(true);
        try {
            const response = await Apiconnection.post('validate-customer-register-otp', {
                email: data.email,
                phone: data.phone,
                emailOTP: otpEmail,
                // phoneOTP: otpPhone,
                deviceType: 2
            });

            if (response.data.status) {
                toast.success("Registration successful!");
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            }
             else {
                toast.error("Invalid OTP. Please try again.");
            }
        } catch (error) {
            console.error("Error during OTP validation:", error);
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
            // setOtpModalOpen(false); // Close the modal after submission
            setOtpEmail('')
        }
    };

    
    const handleCloseModal = () => {
        setOtpModalOpen(false);
        setOtpEmail('');
        setOtpPhone('');
    };

    const handleBack = () => {
        navigate(-1);
    };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: "'Inter', 'Poppins', sans-serif", backgroundColor: '#f0f4f8' }}>
      <style>
        {`
          @keyframes rotate-border {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animated-border-wrapper {
            position: relative;
            padding: 3px;
            border-radius: 26px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          }
          @media (max-width: 576px) {
            .animated-border-wrapper {
              border-radius: 16px;
            }
          }
          .animated-border-wrapper::before {
            content: '';
            position: absolute;
            width: 150%;
            height: 150%;
            background: conic-gradient(
              from 0deg,
              transparent 0%,
              transparent 40%,
              #004777 50%,
              #22c55e 60%,
              transparent 70%,
              transparent 100%
            );
            animation: rotate-border 12s linear infinite;
            z-index: 0;
          }
          .login-card-inner {
            position: relative;
            z-index: 1;
            background: #fff;
            border-radius: 24px;
            width: 100%;
            overflow: hidden;
          }
          @media (max-width: 576px) {
            .login-card-inner {
              border-radius: 14px;
            }
          }
          .login-page-container {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
          }
          @media (max-width: 576px) {
            .login-page-container {
              padding: 10px;
            }
          }
          .login-left-panel {
            width: 100%;
            padding: 40px 50px;
            display: flex;
            flex-direction: column;
            min-height: 100%;
            box-sizing: border-box;
          }
          @media (max-width: 1200px) {
            .login-left-panel {
              padding: 40px 40px;
            }
          }
          @media (max-width: 576px) {
            .login-left-panel {
              padding: 30px 20px;
            }
          }
          .login-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
            gap: 15px;
          }
          @media (max-width: 400px) {
            .login-header {
              flex-direction: column;
              align-items: flex-start;
              gap: 15px;
              margin-bottom: 25px;
            }
          }
          .button-container {
            display: flex;
            gap: 15px;
            margin-top: 10px;
          }
          @media (max-width: 480px) {
            .button-container {
              flex-direction: column-reverse;
              gap: 10px;
            }
          }
          .login-trust-badges {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            padding-top: 30px;
            border-top: 1px solid #eee;
            gap: 15px;
          }
          @media (max-width: 768px) {
            .login-trust-badges {
              flex-wrap: wrap;
              gap: 20px 15px;
            }
            .login-trust-badges > div {
              flex: 1 1 200px;
            }
          }
          @media (max-width: 480px) {
            .login-trust-badges {
              flex-direction: column;
              gap: 15px;
            }
            .login-trust-badges > div {
              flex: initial;
            }
          }
          .login-footer {
            background-color: #0a192f;
            color: #fff;
            min-height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 30px;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 20px;
            box-sizing: border-box;
          }
          .login-footer-separator {
            width: 1px;
            height: 20px;
            background-color: #334155;
          }
          @media (max-width: 768px) {
            .login-footer {
              flex-direction: column;
              gap: 12px;
              padding: 20px;
              text-align: center;
            }
            .login-footer-separator {
              display: none;
            }
          }
        `}
      </style>
      <div className="container-fluid login-page-container">
        <div className="animated-border-wrapper" style={{ maxWidth: '1440px', width: '100%' }}>
          <div className="row w-100 login-card-inner" style={{ margin: '0' }}>
          {/* Left Side */}
          <div className="col-lg-6 col-12 p-0" style={{ display: 'flex' }}>
            <div className="login-left-panel">
          
          <div className="login-header">
            <div>
              <img src={image.logo} alt="Prime Park Logo" style={{ width: '140px' }} />
            </div>
            <div onClick={() => navigate('/')} style={{ color: '#004777', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px' }}>
              <ArrowBackIcon fontSize="small" /> Back to Home
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '28px', fontWeight: '800', color: '#1a1a1a', marginBottom: '8px' }}>Create Account</h2>
            <p style={{ color: '#666', fontSize: '15px', marginBottom: '30px' }}>Join Prime Park for a premium parking experience</p>

            <div className="login-form-sec customer-reg-form-sec">
              <div style={{ marginBottom: '15px', color: '#666', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                Just a few details to get started
              </div>

              <div className="form-container">
                <form action="">
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.firstName ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <PersonOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                          <input 
                            type="text" 
                            name="firstName" 
                            placeholder="First Name" 
                            onChange={handleChange} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                        </div>
                        {showError(error?.firstName)}
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.lastName ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <PersonOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                          <input 
                            type="text" 
                            name="lastName" 
                            placeholder="Last Name" 
                            onChange={handleChange} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                        </div>
                        {showError(error?.lastName)}
                      </div>
                    </div>

                    <div className="col-md-12 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.email ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <MailOutlineIcon style={{ color: '#999', marginRight: '10px' }} />
                          <input 
                            type="email" 
                            name="email" 
                            placeholder="Email Address" 
                            onChange={handleChange} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                        </div>
                        {showError(error?.email)}
                      </div>
                    </div>

                    <div className="col-md-12 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.phone ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <PhoneOutlinedIcon style={{ color: '#999', marginRight: '10px' }} />
                          <div style={{ borderRight: '1px solid #eee', paddingRight: '10px', marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                            <FlagDropdown onSelect={(code) => setData(prev => ({ ...prev, dialcode: code }))} />
                          </div>
                          <input 
                            type="text" 
                            name="phone" 
                            placeholder="Mobile Number" 
                            onChange={handleChange} 
                            maxLength={15} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                        </div>
                        {showError(error?.phone)}
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.password ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <LockOutlinedIcon style={{ color: '#999', marginRight: '10px' }} />
                          <input 
                            type={showPassword ? "text" : "password"} 
                            name="password" 
                            placeholder="Password" 
                            onChange={handleChange} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                          <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={handleTogglePasswordVisibility}>
                            {showPassword ? <VisibilityOff style={{ color: '#AEAEAE' }} /> : <Visibility style={{ color: '#AEAEAE' }} />}
                          </span>
                        </div>
                        {showError(error?.password)}
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.confirmPassword ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <LockOutlinedIcon style={{ color: '#999', marginRight: '10px' }} />
                          <input 
                            type={showPassword2 ? "text" : "password"} 
                            name="confirmPassword" 
                            placeholder="Confirm Password" 
                            onChange={handleChange} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                          <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={handleTogglePasswordVisibility2}>
                            {showPassword2 ? <VisibilityOff style={{ color: '#AEAEAE' }} /> : <Visibility style={{ color: '#AEAEAE' }} />}
                          </span>
                        </div>
                        {showError(error?.confirmPassword)}
                      </div>
                    </div>

                    <div className="col-md-12 mb-4">
                      <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: error.address ? '2px solid #ff4d4f' : '1px solid #e0e0e0', borderRadius: '12px', padding: '0 15px', height: '56px', backgroundColor: '#fff' }}>
                          <LocationOnOutlinedIcon style={{ color: '#999', marginRight: '10px' }} />
                          <input 
                            type="text" 
                            name="address" 
                            placeholder="Full Address" 
                            onChange={handleChange} 
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', backgroundColor: 'transparent' }} 
                          />
                        </div>
                        {showError(error?.address)}
                      </div>
                    </div>
                  </div>

                  <div className="button-container">
                    <button 
                      type="button" 
                      onClick={handleBack}
                      style={{ flex: 1, height: '56px', backgroundColor: '#f5f5f5', color: '#666', border: 'none', borderRadius: '100px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.3s' }}>
                      Cancel
                    </button>
                    <button 
                      type="button" 
                      onClick={handleCustomerSubmit} 
                      disabled={loading}
                      style={{ flex: 1, height: '56px', backgroundColor: '#004777', color: '#fff', border: 'none', borderRadius: '100px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.3s', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                      {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : <>Create Account <ArrowForwardIcon fontSize="small" /></>}
                    </button>
                  </div>
                </form>
                <div style={{ textAlign: 'center', fontSize: '15px', color: '#666', marginTop: '25px' }}>
                  Already have an account? <span onClick={() => navigate('/login')} style={{ color: '#004777', fontWeight: '700', cursor: 'pointer' }}>Sign In</span>
                </div>
              </div>
            </div>
          </div>

          <div className="login-trust-badges">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#e6f6eb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ShieldOutlinedIcon style={{ color: '#00a859', fontSize: '20px' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a1a' }}>Secure & Encrypted</div>
                <div style={{ fontSize: '11px', color: '#666' }}>Your data is always safe</div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#e5eff5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <PersonOutlineIcon style={{ color: '#004777', fontSize: '20px' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a1a' }}>Trusted by 10,000+ Users</div>
                <div style={{ fontSize: '11px', color: '#666' }}>Across 50+ cities</div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#efeefd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <HeadsetMicOutlinedIcon style={{ color: '#6658ea', fontSize: '20px' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a1a' }}>24/7 Customer Support</div>
                <div style={{ fontSize: '11px', color: '#666' }}>We're here to help</div>
              </div>
            </div>
          </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-6 d-none d-lg-flex p-0">
            <div style={{ width: '100%', backgroundColor: '#f8fafc', backgroundImage: `url(${image.bodybg})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '40px 50px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ alignSelf: 'flex-end', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '700', color: '#0f172a', fontSize: '15px' }}>
            <ShieldOutlinedIcon fontSize="small" style={{ color: '#0f172a' }} /> Secure & Encrypted
          </div>
          
          <div style={{ marginTop: 'auto', marginBottom: 'auto', display: 'flex', flexDirection: 'column' }}>
            <h1 style={{ fontSize: '56px', fontWeight: '900', lineHeight: '1.1', textAlign: 'left', marginBottom: '16px', color: '#0f172a', letterSpacing: '-1px' }}>
              Smart Parking.<br/>
              <span style={{ color: '#22c55e' }}>Hassle Free.</span>
            </h1>
            <p style={{ fontSize: '18px', color: '#475569', maxWidth: '420px', textAlign: 'left', marginBottom: '40px', lineHeight: '1.6', fontWeight: '500' }}>
              Book your spot in advance and enjoy a seamless parking experience.
            </p>
            
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '60px' }}>
              <img src={image.car} alt="Cars" style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', margin: '0 -10px' }}>
              <FeatureIcon icon={<CalendarTodayOutlinedIcon style={{color: '#22c55e', fontSize: '28px'}}/>} bgColor="#dcfce7" title="Book in Advance" desc="Reserve your spot anytime, anywhere" hasBorder={true} />
              <FeatureIcon icon={<DirectionsCarOutlinedIcon style={{color: '#3b82f6', fontSize: '28px'}}/>} bgColor="#dbeafe" title="Park with Ease" desc="Safe, secure & well-maintained facilities" hasBorder={true} />
              <FeatureIcon icon={<AccessTimeOutlinedIcon style={{color: '#6366f1', fontSize: '28px'}}/>} bgColor="#e0e7ff" title="Save Time" desc="No waiting, no last-minute stress" hasBorder={true} />
              <FeatureIcon icon={<ShieldOutlinedIcon style={{color: '#f59e0b', fontSize: '28px'}}/>} bgColor="#fef3c7" title="Safe & Secure" desc="24/7 surveillance for your peace of mind" hasBorder={false} />
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Footer */}
      <div className="login-footer">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <HeadsetMicOutlinedIcon fontSize="small" /> Need help? We're here for you!
        </div>
        <div className="login-footer-separator"></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <PhoneOutlinedIcon fontSize="small" /> +1 800-884-0153
        </div>
        <div className="login-footer-separator"></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <MailOutlineIcon fontSize="small" /> support@primepark.com
        </div>
      </div>



{/* OTP Modal */}
<Modal open={otpModalOpen} onClose={handleCloseModal}>
    <div className="terms-modal" style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '40px 30px',
        border: 'none',
        borderRadius: '24px',
        width: '100%',
        maxWidth: '420px',
        boxShadow: '0 25px 80px rgba(0, 0, 0, 0.2)',
        textAlign: 'center'
    }}>
        <div style={{ 
            width: '70px', 
            height: '70px', 
            backgroundColor: '#f0f7ff', 
            borderRadius: '100px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 20px'
        }}>
            <MailOutlineIcon style={{ fontSize: '35px', color: '#004777' }} />
        </div>
        
        <h3 style={{ marginBottom: '10px', fontWeight: '800', color: '#1a1a1a', fontSize: '24px' }}>Check Your Email</h3>
        <p style={{ color: '#666', fontSize: '15px', marginBottom: '30px', lineHeight: '1.5' }}>
            We've sent a 4-digit verification code to your email address. Please enter it below to continue.
        </p>
        
        <div style={{ marginBottom: '30px', textAlign: 'left' }}>
            <label htmlFor="emailOtp" style={{ display: 'block', marginBottom: '10px', fontWeight: '600', color: '#333', fontSize: '14px' }}>Verification Code</label>
            <input 
                type="text" 
                id="emailOtp" 
                value={otpEmail} 
                onChange={(e) => setOtpEmail(e.target.value)} 
                placeholder="0 0 0 0"
                maxLength={4}
                style={{ 
                    width: '100%', 
                    padding: '15px', 
                    border: '1px solid #e0e0e0', 
                    borderRadius: '12px', 
                    fontSize: '20px', 
                    fontWeight: '700',
                    letterSpacing: '8px',
                    textAlign: 'center',
                    outline: 'none',
                    backgroundColor: '#fcfcfc',
                    color: '#004777',
                    transition: 'border-color 0.3s'
                }} 
                onFocus={(e) => e.target.style.borderColor = '#004777'}
                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
            />
        </div>

        <button 
            onClick={handleOtpSubmit}
            disabled={loading}
            style={{
                width: '100%', 
                padding: '16px', 
                backgroundColor: loading ? '#80a3bb' : '#004777', 
                color: 'white', 
                border: 'none', 
                borderRadius: '12px', 
                fontSize: '16px',
                fontWeight: '700',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 8px 25px rgba(0, 71, 119, 0.25)'
            }}
            onMouseOver={(e) => { if(!loading) { e.target.style.backgroundColor = '#003355'; e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 12px 30px rgba(0, 71, 119, 0.35)'; } }} 
            onMouseOut={(e) => { if(!loading) { e.target.style.backgroundColor = '#004777'; e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 8px 25px rgba(0, 71, 119, 0.25)'; } }}
        >
            {loading ? <CircularProgress size={24} sx={{ color: '#000000' }} /> : 'Verify & Create Account'}
        </button>
        
        <p style={{ marginTop: '25px', fontSize: '14px', color: '#888' }}>
            Didn't receive the code? <span style={{ color: '#004777', fontWeight: '600', cursor: 'pointer' }}>Resend</span>
        </p>
    </div>
</Modal>

      </div>
    );
};

export default CustomerRegistration;